
























































































































import Vue from "vue";
import InputGroup from "@/components/Form/InputGroup.vue";
import CheckboxGroup from "@/components/Form/CheckboxGroup.vue";
import VueRecaptcha from "vue-recaptcha";
import { mapState, mapMutations } from "vuex";
import {
  RootState,
  SET_SUCCESS,
  SET_QUESTIONNAIRE_ERROR,
  SET_QUESTIONNAIRE_STEP
} from "@/store/types";
import messages from "@/messages.json";
import axios from "axios";
export default Vue.extend({
  name: "UserData",

  data: () => ({
    isLoading: false,
    successMessage: ""
  }),

  components: {
    InputGroup,
    CheckboxGroup,
    Loader: () => import("@/components/UI/Loader.vue"),
    Error: () => import("@/components/Form/Error.vue"),
    SuccessCard: () => import("@/components/Form/SuccessCard.vue"),
    VueRecaptcha
  },

  computed: {
    ...mapState({
      userData: state => (state as RootState).userData,
      survey: state => (state as RootState).survey,
      success: state => (state as RootState).success,
      error: state => (state as RootState).questionnaireError,
      steps: state => (state as RootState).questionnaireSteps
    }),

    selectedLayers() {
      return this.survey.layers
        .filter(layer => layer.isSelected)
        .map(layer => ({
          id: layer.id
        }));
    }
  },

  methods: {
    ...mapMutations({
      setSuccess: SET_SUCCESS,
      setError: SET_QUESTIONNAIRE_ERROR,
      setCurrentStep: SET_QUESTIONNAIRE_STEP
    }),

    goHome() {
      this.setCurrentStep(this.steps[0].order);
      this.setSuccess(false);
    },

    submitData() {
      this.$refs.recaptcha.execute();
    },

    async onCaptchaVerified(recaptchaToken) {
      this.$refs.recaptcha.reset();

      if (this.validateData()) {
        this.isLoading = true;
        this.setError(null);

        const uploadedFiles = this.userData.uploadedFiles.map(file => ({
          id: file.id
        }));

        const surveyData = {
          ...this.userData,
          surveyId: this.survey.id,
          uploadedFiles,
          selectedLayers: this.selectedLayers
        };

        try {
          await axios.post("", { ...surveyData, recaptchaToken });
          this.successMessage = messages.success.questionnaire;
          this.setSuccess(true);
        } catch (err) {
          const { error } = messages;
          const code = err.response.data.code;

          if (code && code in error) {
            this.setError(error[code]);
          } else {
            this.setError(error["survey_post"]);
          }

          setTimeout(() => {
            this.setError(null);
          }, 5000);
        }

        this.isLoading = false;
      }
    },

    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },

    validateData(): boolean {
      const { firstName, lastName, phone, consent } = this.userData;
      const {
        streetNumber,
        postalCode,
        county,
        town,
        municipality
      } = this.userData.address;
      const { error } = messages;

      if (firstName.length < 3) {
        this.setError(error["bad_first_name"]);
        return false;
      } else if (lastName.length < 3) {
        this.setError(error["bad_last_name"]);
        return false;
      } else if (phone.length < 9) {
        this.setError(error["bad_phone"]);
        return false;
      } else if (this.selectedLayers.length === 0) {
        this.setError(error["bad_selected_layers"]);
        return false;
      } else if (!county) {
        this.setError(error["bad_county"]);
        return false;
      } else if (!municipality) {
        this.setError(error["bad_municipality"]);
        return false;
      } else if (postalCode.length < 5) {
        this.setError(error["bad_postalCode"]);
        return false;
      } else if (!town) {
        this.setError(error["bad_town"]);
        return false;
      } else if (!streetNumber) {
        this.setError(error["bad_streetNumber"]);
        return false;
      } else if (!consent) {
        this.setError(error["bad_consent"]);
        return false;
      }

      return true;
    }
  }
});
